import $ from "jquery";
import Handlebars from "handlebars";

import { getTemplate } from "../handlebars";

export default class DashboardPage {
    /**
     * This function sends a GET request to the server to retrieve the serialised data for all product groups.
     * This data is passed to the loadProductGroups function.
     */
    requestProductGroups(url = pageData.productListURL, allProducts = []) {
        $.ajax({
            url: `${url}`,
            type: "GET",
            success: function (data) {
                allProducts.push(...(data.results || []));

                if (data.next) {
                    this.requestProductGroups(data.next, allProducts);
                    return;
                }

                this.loadProductGroups({ results: allProducts });
            }.bind(this),
        });
    }

    /**
     * This function adds the product group cards to the dashboard.
     * It uses the data from the server to build a card for each product.
     * @param {object} data - The serialised dataset product groups.
     */
    loadProductGroups(data) {
        $("#product-group-cards").empty();
        data.results.forEach(function (product) {
            const name = product.name;
            let image_url = product.image;

            if (!image_url) {
                image_url = pageData.imageUrl;
            }
            let description = product.description;
            if (!description) {
                description = "No description";
            }
            const datasetCount = product.dataset_count;
            const isSubscribed = product.is_subscribed;
            const url = pageData.uiHomeURL + "?products=" + product.slug;
            const detail_url = pageData.productDetailURL.replace('slug', product.slug)
            let card = document.createElement("div");
            card.className = "col-sm-6 col-md-4 pb-4";

            card.innerHTML = Handlebars.partials.productGroupCard({
                name,
                image_url,
                description,
                datasetCount,
                url,
                isSubscribed,
                detail_url,
            });
            document.getElementById("product-group-cards").appendChild(card);
        });
    }
    ready() {
        for (const [key, value] of Object.entries(pageData.partials)) {
            getTemplate(value, key);
        }
        this.requestProductGroups();
    }
}
